const API = window.location.origin;

// In-memory set of IDs already prefetched this session — prevents duplicate
// requests when a card scrolls in and out of view multiple times.
const prefetched = new Set();

export function prefetchPoem(poemId) {
  if (!poemId || prefetched.has(poemId)) return;
  prefetched.add(poemId);
  // Low-priority background fetch — stores result in the browser's HTTP cache.
  // When the user navigates, the Poem screen's fetch hits the cache instantly.
  fetch(`${API}/api/poems/${poemId}`, {
    priority: 'low',
    // credentials omitted intentionally — poem data is public
  }).catch(() => {
    // Non-fatal — if prefetch fails the real fetch will handle it
    prefetched.delete(poemId);
  });
}

export function prefetchFeatured(poemId) {
  prefetchPoem(poemId);
}
